import { render, staticRenderFns } from "./vue-ckeditor.vue?vue&type=template&id=461c247e&scoped=true&"
import script from "./vue-ckeditor.vue?vue&type=script&lang=js&"
export * from "./vue-ckeditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461c247e",
  null
  
)

export default component.exports